// ============================================================================
// HINDI TRANSLATIONS - CHAPTER 3: यीशु मसीह
// ============================================================================
// Levels 27-39 (13 स्तर, 39 प्रश्न)

export const chapter3Translations = {
  name: 'यीशु मसीह',
  description: 'वचन देहधारी हुआ... मसीह को जानना अनन्त जीवन है',
  
  spiritualWisdom: {
    principle: 'यीशु मसीह को जानना अनन्त जीवन है',
    scripture: 'और अनन्त जीवन यह है कि वे तुझ अद्वितीय सच्चे परमेश्वर को और यीशु मसीह को जिसे तूने भेजा है, जानें (यूहन्ना 17:3)',
    application: 'यीशु के जीवन का हर पहलू परमेश्वर को प्रकट करता है और हमारी आत्मा को अनन्तता के लिए पोषण देता है'
  },
  
  levels: {
    27: {
      name: 'घोषणा',
      challenge: 'स्वर्गदूत जिब्राईल परमेश्वर की ओर से गलील के एक नगर को भेजा गया...',
      easy: {
        question: 'किस स्वर्गदूत ने मरियम को बताया कि वह यीशु को जन्म देगी?',
        options: ['मीकाईल', 'जिब्राईल', 'राफेल', 'ऊरिएल'],
        hint: 'परमेश्वर का दूत',
        funFact: '👼 जिब्राईल का अर्थ है परमेश्वर की शक्ति - महान घोषणाओं का दूत!'
      },
      medium: {
        question: 'इस घोषणा पर मरियम की पहली प्रतिक्रिया क्या थी?',
        options: [
          'तत्काल आनंद',
          'पूर्ण अविश्वास',
          'भ्रम और प्रश्न यह कैसे होगा?',
          'भय'
        ],
        hint: 'एक व्यावहारिक और वैध प्रश्न',
        funFact: '🤔 मरियम एक तार्किक प्रश्न पूछती है लेकिन परमेश्वर के प्रति खुला दिल रखती है!'
      },
      hard: {
        question: 'मरियम की दैवीय इच्छा के प्रति समर्पण हमें क्या सिखाता है?',
        options: [
          'परीक्षाओं के सामने निष्क्रियता',
          'विश्वास जो सब कुछ समझे बिना भरोसा करता है',
          'अंधा आज्ञाकारिता',
          'त्याग'
        ],
        hint: 'यह अज्ञात में भी परमेश्वर पर भरोसा करने के बारे में है',
        funFact: '🙏 मुझ में तेरे वचन के अनुसार हो - भरोसेमंद विश्वास का मॉडल!'
      }
    },
    
    28: {
      name: 'जन्म',
      challenge: 'उसने अपने पहलौठे बेटे को जन्म दिया, उसे कपड़ों में लपेटा और चरनी में रखा...',
      easy: {
        question: 'यीशु का जन्म किस शहर में हुआ?',
        options: ['नासरत', 'यरूशलेम', 'बैतलहम', 'कफरनहूम'],
        hint: 'दाऊद का नगर',
        funFact: '🏘️ बैतलहम का अर्थ है रोटी का घर - यीशु, जीवन की रोटी!'
      },
      medium: {
        question: 'जन्म की घोषणा सबसे पहले किसे मिली?',
        options: [
          'ज्ञानियों',
          'मैदान में चरवाहों',
          'मंदिर के पुजारियों',
          'मरियम के परिवार'
        ],
        hint: 'सरल लोग जो अपने झुंड की रखवाली कर रहे थे',
        funFact: '🐑 परमेश्वर पहले विनम्र चरवाहों को घोषणा करता है - सभी के लिए सुसमाचार!'
      },
      hard: {
        question: 'चरनी में जन्मे यीशु क्या प्रतीक है?',
        options: [
          'उसके माता-पिता की गरीबी',
          'परमेश्वर की विनम्रता जो हम तक झुकता है',
          'जगह की कमी',
          'ग्रामीण सादगी'
        ],
        hint: 'यह विनम्रता में दैवीय अवतार के बारे में है',
        funFact: '👶 ब्रह्मांड का सृष्टिकर्ता एक अस्तबल में पैदा हुआ - अनंत प्रेम!'
      }
    },

    29: {
      name: 'पूर्व के ज्ञानी',
      challenge: 'पूर्व से ज्ञानी यरूशलेम आए और पूछा...',
      easy: {
        question: 'ज्ञानियों को यीशु के पास क्या ले गया?',
        options: ['एक स्वर्गदूत', 'एक तारा', 'एक दर्शन', 'एक नक्शा'],
        hint: 'आकाश में एक ज्योति',
        funFact: '⭐ तारा दर्शाता है कि यीशु राष्ट्रों का प्रकाश है!'
      },
      medium: {
        question: 'ज्ञानियों ने कौन से उपहार अर्पित किए?',
        options: [
          'भोजन',
          'सोना, लोबान और गंधरस',
          'कीमती वस्त्र',
          'खिलौने'
        ],
        hint: 'तीन प्रतीकात्मक और कीमती उपहार',
        funFact: '🎁 सोना (राजत्व), लोबान (दिव्यता), गंधरस (बलिदान) - यीशु का पूरा मिशन!'
      },
      hard: {
        question: 'ये अन्यजाति ज्ञानी परमेश्वर की योजना में क्या दर्शाते हैं?',
        options: [
          'अन्य धर्मों की श्रेष्ठता',
          'सभी लोगों को दिए गए उद्धार की सार्वभौमिकता',
          'भौतिक संपदा',
          'प्राचीन विज्ञान'
        ],
        hint: 'यह सभी राष्ट्रों के लिए उद्धार के खुलने के बारे में है',
        funFact: '🌍 ज्ञानी सुसमाचार का पूर्वाभास देते हैं जो पूरी दुनिया तक पहुंचेगा!'
      }
    },

    30: {
      name: 'यीशु का बपतिस्मा',
      challenge: 'जैसे ही यीशु ने बपतिस्मा लिया, वह तुरंत पानी से ऊपर आया...',
      easy: {
        question: 'यीशु को किसने बपतिस्मा दिया?',
        options: ['पतरस', 'यूहन्ना बपतिस्मा देनेवाला', 'अन्द्रियास', 'याकूब'],
        hint: 'यीशु का अग्रदूत',
        funFact: '🌊 यूहन्ना बपतिस्मा देनेवाला यीशु के जूते का बंधन खोलने के योग्य नहीं समझता था!'
      },
      medium: {
        question: 'उसके बपतिस्मा पर यीशु पर क्या उतरा?',
        options: [
          'एक प्रकाश',
          'एक कबूतर (पवित्र आत्मा)',
          'एक स्वर्गदूत',
          'केवल एक आवाज'
        ],
        hint: 'शांति का प्रतीक पक्षी',
        funFact: '🕊️ कबूतर सेवकाई शुरू करने के लिए दैवीय अभिषेक को प्रकट करता है!'
      },
      hard: {
        question: 'निष्पाप यीशु ने बपतिस्मा क्यों लिया?',
        options: [
          'उदाहरण देने के लिए',
          'सभी धार्मिकता को पूरा करने और हमारे साथ पहचान बनाने के लिए',
          'धार्मिक दायित्व के कारण',
          'क्षमा प्राप्त करने के लिए'
        ],
        hint: 'यह पापी मानवता के साथ एकजुटता के बारे में है',
        funFact: '❤️ यीशु हमें बेहतर तरीके से बचाने के लिए पूरी तरह से हमारे साथ पहचान बनाता है!'
      }
    },

    31: {
      name: 'जंगल में परीक्षा',
      challenge: 'यीशु को आत्मा द्वारा जंगल में ले जाया गया ताकि शैतान द्वारा परखा जाए...',
      easy: {
        question: 'यीशु ने जंगल में कितने समय तक उपवास किया?',
        options: ['30 दिन', '40 दिन', '50 दिन', '60 दिन'],
        hint: 'परीक्षा की बाइबिल संख्या',
        funFact: '🏜️ मूसा और एलिय्याह की तरह, 40 दिन की गहन आत्मिक तैयारी!'
      },
      medium: {
        question: 'यीशु ने प्रत्येक परीक्षा को कैसे अस्वीकार किया?',
        options: [
          'अपनी शक्ति से',
          'पवित्रशास्त्र उद्धृत करके',
          'शैतान को नजरअंदाज करके',
          'केवल प्रार्थना से'
        ],
        hint: 'उत्कृष्ट आध्यात्मिक हथियार',
        funFact: '📖 लिखा है... - परमेश्वर का वचन, आत्मा की तलवार!'
      },
      hard: {
        question: 'यीशु की परीक्षा हमारे संघर्षों के बारे में क्या सिखाती है?',
        options: [
          'परीक्षाएं पाप हैं',
          'वचन और विश्वास द्वारा परीक्षा पर विजय प्राप्त की जा सकती है',
          'हर जंगल से भागना चाहिए',
          'केवल यीशु ही प्रतिरोध कर सकता है'
        ],
        hint: 'यह परीक्षाओं के खिलाफ हमारी रणनीति के बारे में है',
        funFact: '⚔️ यीशु हमें दिखाता है कि कैसे जीतें: परमेश्वर का वचन + सक्रिय विश्वास!'
      }
    },

    32: {
      name: 'पहले चेले',
      challenge: 'यीशु ने उनसे कहा: मेरे पीछे आओ, और मैं तुम्हें मनुष्यों के पकड़नेवाले बनाऊंगा...',
      easy: {
        question: 'पतरस और अन्द्रियास का व्यवसाय क्या था?',
        options: ['चरवाहे', 'मछुआरे', 'बढ़ई', 'कर वसूलने वाले'],
        hint: 'गलील झील का एक व्यवसाय',
        funFact: '🎣 यीशु मछली पकड़ने वालों को आत्माओं के पकड़ने वालों में बदल देता है!'
      },
      medium: {
        question: 'पहले चेलों ने बुलावे पर कैसे प्रतिक्रिया दी?',
        options: [
          'उन्होंने बहुत देर तक संकोच किया',
          'उन्होंने प्रमाण मांगे',
          'उन्होंने सब कुछ छोड़ दिया और तुरंत उसके पीछे चल दिए',
          'उन्होंने बातचीत की'
        ],
        hint: 'एक तत्काल और पूर्ण प्रतिक्रिया',
        funFact: '🚶 यीशु का अधिकार इतना स्पष्ट था कि उन्होंने तुरंत आज्ञा मानी!'
      },
      hard: {
        question: 'हमारे समय में यीशु के पीछे चलने का क्या अर्थ है?',
        options: [
          'काम छोड़ देना',
          'उसकी शिक्षाओं और इच्छा के अनुसार जीना',
          'एक अलग समुदाय में शामिल होना',
          'केवल प्रचार करना'
        ],
        hint: 'यह जीवन और प्राथमिकताओं के परिवर्तन के बारे में है',
        funFact: '✨ यीशु के पीछे चलना हमारे दिल, विकल्प, नियति को बदल देता है!'
      }
    },

    33: {
      name: 'पहाड़ पर उपदेश',
      challenge: 'धन्य हैं वे जो मन के दीन हैं, क्योंकि स्वर्ग का राज्य उन्हीं का है...',
      easy: {
        question: 'पहाड़ पर उपदेश में पहला धन्यवाद क्या है?',
        options: [
          'धन्य हैं वे जो हृदय के शुद्ध हैं',
          'धन्य हैं वे जो मन के दीन हैं',
          'धन्य हैं नम्र',
          'धन्य हैं मेल करानेवाले'
        ],
        hint: 'आत्मिक विनम्रता से संबंधित',
        funFact: '😊 मन के दीन अपनी परमेश्वर की आवश्यकता जानते हैं - राज्य का द्वार!'
      },
      medium: {
        question: 'मेल करानेवालों के बारे में यीशु ने क्या कहा?',
        options: [
          'वे भाग्यशाली होंगे',
          'वे परमेश्वर के पुत्र कहलाएंगे',
          'वे प्रिय होंगे',
          'वे शक्तिशाली होंगे'
        ],
        hint: 'एक विशेष दैवीय पहचान',
        funFact: '👑 शांति बनाने वाले परमेश्वर के समान हैं - उसकी प्रकृति की जीवित गवाही!'
      },
      hard: {
        question: 'धन्यवाद दुनिया के मूल्यों को कैसे उलट देते हैं?',
        options: [
          'धन की निंदा करके',
          'विश्वासियों को अलग करके',
          'उन पर आशीष की घोषणा करके जिन्हें दुनिया तुच्छ जानती है',
          'कानूनों को समाप्त करके'
        ],
        hint: 'यह सांसारिक मूल्यों के विपरीत दैवीय मूल्यों के बारे में है',
        funFact: '🔄 धन्यवाद हमारी खुशी और सफलता की दृष्टि को बदल देते हैं!'
      }
    },

    34: {
      name: 'राज्य के दृष्टान्त',
      challenge: 'उसने उन्हें दृष्टान्तों में बहुत सी बातें सिखाईं...',
      easy: {
        question: 'बोने वाले के दृष्टान्त में, बीज क्या दर्शाता है?',
        options: [
          'धन',
          'परमेश्वर का वचन',
          'अच्छे काम',
          'प्रेम'
        ],
        hint: 'जो यीशु घोषित करता और सिखाता है',
        funFact: '🌱 परमेश्वर का वचन हमारे हृदयों में अंकुरित होता और बढ़ता है!'
      },
      medium: {
        question: 'राई के दाने के दृष्टान्त में, यह छोटा बीज क्या प्रतीक है?',
        options: [
          'मानवीय कमजोरी',
          'राज्य जो छोटा शुरू होता है लेकिन बड़ा हो जाता है',
          'विवरणों का महत्व',
          'प्रकृति'
        ],
        hint: 'कुछ ऐसा जो शानदार ढंग से बढ़ता है',
        funFact: '🌳 सबसे छोटे बीज से एक बड़ा पेड़ पैदा होता है - राज्य की शक्ति!'
      },
      hard: {
        question: 'यीशु ने दृष्टान्तों में क्यों पढ़ाया?',
        options: [
          'अपने संदेश को जटिल बनाने के लिए',
          'परिचित चित्रों के माध्यम से आत्मिक सत्य प्रकट करने के लिए',
          'समय की कमी के कारण',
          'बुद्धि का परीक्षण करने के लिए'
        ],
        hint: 'यह राज्य के रहस्यों को सुलभ बनाने के बारे में है',
        funFact: '💡 दृष्टान्त खुले हृदयों के लिए प्रकट करते हैं और बंद हृदयों के लिए छिपाते हैं!'
      }
    },

    35: {
      name: 'यीशु के चमत्कार',
      challenge: 'उसने आँधी को शांत किया और समुद्र से कहा: शांत हो! थम जा!...',
      easy: {
        question: 'यीशु ने 5000 पुरुषों को कितनी रोटियों से खिलाया?',
        options: ['3 रोटियाँ', '5 रोटियाँ', '7 रोटियाँ', '12 रोटियाँ'],
        hint: 'मछलियों की संख्या के समान',
        funFact: '🍞 5 रोटियाँ और 2 मछलियाँ एक दावत बन जाती हैं - दैवीय उदारता!'
      },
      medium: {
        question: 'जब यीशु ने तूफान शांत किया तो शिष्यों ने क्या कहा?',
        options: [
          'वह जादूगर है',
          'यह कौन है जिसकी हवा और समुद्र भी आज्ञा मानते हैं?',
          'यह सामान्य है',
          'हमें यहाँ से जाना चाहिए'
        ],
        hint: 'यीशु की पहचान के बारे में एक प्रश्न',
        funFact: '⛈️ तत्व भी अपने सृष्टिकर्ता और स्वामी को पहचानते हैं!'
      },
      hard: {
        question: 'यीशु के चमत्कारों का मुख्य उद्देश्य क्या है?',
        options: [
          'भीड़ को प्रभावित करना',
          'अपनी दिव्यता प्रकट करना और परमेश्वर का प्रेम प्रकट करना',
          'प्रभाव प्राप्त करना',
          'केवल भौतिक रूप से मदद करना'
        ],
        hint: 'यह दैवीय प्रकाशन और करुणा के बारे में है',
        funFact: '❤️ हर चमत्कार परमेश्वर के हृदय को प्रकट करता है: प्रेम, करुणा, शक्ति!'
      }
    },

    36: {
      name: 'रूपान्तरण',
      challenge: 'वह उनके सामने रूपान्तरित हुआ; उसका चेहरा सूर्य की तरह चमक उठा...',
      easy: {
        question: 'किन शिष्यों ने यीशु को रूपान्तरित देखा?',
        options: [
          'सभी बारह',
          'पतरस, याकूब और यूहन्ना',
          'केवल पतरस और यूहन्ना',
          'जो महिलाएं उसके पीछे चलती थीं'
        ],
        hint: 'तीन की अंतरंग मंडली',
        funFact: '⛰️ पतरस, याकूब और यूहन्ना: दिव्य महिमा के विशेषाधिकार प्राप्त गवाह!'
      },
      medium: {
        question: 'पुराने नियम के कौन से चरित्र प्रकट हुए?',
        options: [
          'अब्राहम और इसहाक',
          'दाऊद और सुलैमान',
          'मूसा और एलिय्याह',
          'आदम और नूह'
        ],
        hint: 'व्यवस्था का प्रतिनिधि और भविष्यवक्ताओं का',
        funFact: '📜 मूसा (व्यवस्था) और एलिय्याह (भविष्यवक्ता) यीशु की गवाही देते हैं!'
      },
      hard: {
        question: 'यह रूपान्तरण यीशु की प्रकृति के बारे में क्या प्रकट करता है?',
        options: [
          'वह एक महान भविष्यवक्ता है',
          'उसकी छिपी दिव्यता अस्थायी रूप से प्रकट होती है',
          'वह प्रकाश को नियंत्रित करता है',
          'वह रूप बदल सकता है'
        ],
        hint: 'यह उसकी दिव्य प्रकृति के प्रकाशन के बारे में है',
        funFact: '✨ यीशु की दिव्य महिमा चमकती है - उसके पुनरुत्थान की झलक!'
      }
    },

    37: {
      name: 'विजयी प्रवेश',
      challenge: 'दाऊद के पुत्र का होशाना! धन्य है वह जो प्रभु के नाम से आता है!...',
      easy: {
        question: 'यीशु किस जानवर पर यरूशलेम में प्रवेश किया?',
        options: ['घोड़ा', 'गधा', 'ऊँट', 'पैदल'],
        hint: 'विनम्रता और शांति का प्रतीक जानवर',
        funFact: '🐴 गधा विनम्र राजा का प्रतीक है जो शांति में आता है, युद्ध में नहीं!'
      },
      medium: {
        question: 'यीशु की प्रशंसा करते हुए भीड़ ने क्या पुकारा?',
        options: [
          'राजा की जय हो!',
          'होशाना! धन्य है वह जो प्रभु के नाम से आता है!',
          'परमेश्वर की महिमा हो!',
          'स्वतंत्रता!'
        ],
        hint: 'आनंद और आशीर्वाद की पुकार',
        funFact: '🌿 "होशाना" का अर्थ है "अभी बचाओ" - दिव्य उद्धार के लिए आह्वान!'
      },
      hard: {
        question: 'यह प्रवेश "विजयी" लेकिन दुखद क्यों है?',
        options: [
          'बहुत कम लोग थे',
          'जो भीड़ उसकी प्रशंसा करती है वह 5 दिनों में उसे अस्वीकार कर देगी',
          'अधिकारी अनुपस्थित थे',
          'बारिश हो रही थी'
        ],
        hint: 'यह मानव हृदय की अस्थिरता के बारे में है',
        funFact: '💔 वही भीड़ कुछ दिनों बाद "उसे सूली पर चढ़ाओ!" चिल्लाएगी!'
      }
    },

    38: {
      name: 'अंतिम भोज',
      challenge: 'लो और खाओ, यह मेरी देह है जो तुम्हारे लिए दी जाती है...',
      easy: {
        question: 'यीशु ने अपने शिष्यों के पैरों का क्या किया?',
        options: [
          'उन्हें आशीर्वाद दिया',
          'उन्हें धोया',
          'उन्हें सुगंधित किया',
          'उन्हें चूमा'
        ],
        hint: 'विनम्रता और सेवा का एक कार्य',
        funFact: '🦶 गुरु सेवक बन जाता है - प्रेम और विनम्रता की क्रांति!'
      },
      medium: {
        question: 'इस भोज में यीशु ने क्या स्थापित किया?',
        options: [
          'बपतिस्मा',
          'भोज (पवित्र भोज)',
          'प्रभु की प्रार्थना',
          'उपवास'
        ],
        hint: 'रोटी और दाखरस के साथ एक संस्कार',
        funFact: '🍞🍷 रोटी और दाखरस बलिदान और प्रेम के शाश्वत प्रतीक बन जाते हैं!'
      },
      hard: {
        question: '"मेरी स्मृति में यह करो" का क्या अर्थ है?',
        options: [
          'इस भोज को दोहराओ',
          'मेरी मृत्यु और पुनरुत्थान मेरे लौटने तक मनाओ',
          'मेरे वचन याद रखो',
          'एक दूसरे से प्रेम करो'
        ],
        hint: 'यह एक जीवित और भविष्यसूचक स्मरण के बारे में है',
        funFact: '⏳ हर भोज प्रभु के आने तक उसकी मृत्यु की घोषणा करता है!'
      }
    },

    39: {
      name: 'गतसमनी',
      challenge: 'हे मेरे पिता, यदि हो सके तो यह प्याला मुझसे टल जाए...',
      easy: {
        question: 'यीशु ने गिरफ्तारी से पहले कहाँ प्रार्थना की?',
        options: [
          'मंदिर में',
          'गतसमनी के बगीचे में',
          'जैतून के पहाड़ पर',
          'अपने दोस्तों के घर'
        ],
        hint: 'जैतून के पेड़ों का बगीचा',
        funFact: '🫒 गतसमनी का अर्थ है "तेल का कोल्हू" - तीव्र दबाव का स्थान!'
      },
      medium: {
        question: 'यीशु की प्रार्थना के दौरान शिष्यों ने क्या किया?',
        options: [
          'उसके साथ प्रार्थना की',
          'सो गए',
          'पहरा दिया',
          'चले गए'
        ],
        hint: 'वे एक घंटा भी जागते न रह सके',
        funFact: '😴 आत्मा तो तैयार है पर शरीर दुर्बल है - मानवीय कमजोरी!'
      },
      hard: {
        question: 'यीशु की पीड़ा उसकी प्रकृति के बारे में क्या प्रकट करती है?',
        options: [
          'वह केवल मनुष्य था',
          'वह पूर्ण मनुष्य और पूर्ण परमेश्वर था',
          'उसे अपने मिशन पर संदेह था',
          'वह कमजोर था'
        ],
        hint: 'यह अवतार के रहस्य के बारे में है',
        funFact: '✝️ यीशु परमेश्वर के प्रति वफादार रहते हुए मानवीय पीड़ा को पूरी तरह से वहन करता है!'
      }
    }
  }
};

export default chapter3Translations;
